import { useCallback } from 'react';
import { Howl } from 'howler';

const hoverSound = new Howl({
  src: ['https://assets.mixkit.co/active_storage/sfx/2571/2571-preview.mp3'],
  volume: 0.1,
});

const clickSound = new Howl({
  src: ['https://assets.mixkit.co/active_storage/sfx/2572/2572-preview.mp3'],
  volume: 0.2,
});

export const useSound = () => {
  const playHover = useCallback(() => {
    hoverSound.play();
  }, []);

  const playClick = useCallback(() => {
    clickSound.play();
  }, []);

  return { playHover, playClick };
};